/* eslint-disable no-unused-vars */
import { useRef, useId, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { publisherReportsFiltersTableActions } from 'store/actions';
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { useSignal, useComputed } from '@preact/signals-react';
import { useRerender } from 'utils';
import {
  Search,
  Each,
  Buttons,
  Checkbox,
  ParagraphWithTooltip,
  MenuItem,
  CheckboxInner,
} from 'components';
import { Search as SmallSearchIcon } from 'assets/icons';

const getIcon = () => {
  return <SmallSearchIcon />;
};

export const Placement = ({ placementList$ }) => {
  const resetBtnId = useId();
  const applyBtnId = useId();
  const searchId = useId();
  const changingFlag$ = useSignal(false);

  const dispatch = useDispatch();
  const rerender = useRerender();
  const searchRef = useRef(null);
  const searchValue$ = useSignal('');
  const initialPlacementsFilter = useSelector(
    (state) => state.publisherReportsFiltersTable.placementsFilter,
  );
  const placementFilter$ = useSignal(new Set(initialPlacementsFilter));

  const applyClick = () => {
    dispatch(
      publisherReportsFiltersTableActions.updateProperty({
        newValue: Array.from(placementFilter$.value),
        propField: 'placementsFilter',
      }),
    );
    changingFlag$.value = false;
  };

  const resetClick = () => {
    changingFlag$.value = true;
    placementFilter$.value.clear();
    rerender();
  };

  const handleItemClick = (placement_id) => {
    placementFilter$.value.has(placement_id)
      ? placementFilter$.value.delete(placement_id)
      : placementFilter$.value.add(placement_id);
    changingFlag$.value = true;
    rerender();
  };

  const filteredPlacementsList$ = useComputed(() => {
    const res = Array.from(placementList$.value.values()).filter(({ placement, placement_id }) => {
      //if (placement_id.toLowerCase().includes(searchValue$.value.toLowerCase())) return true;
      if (placement.toLowerCase().includes(searchValue$.value.toLowerCase())) return true;
      return false;
    });
    return res;
  });

  const sortedPlacementsList$ = useComputed(() => {
    const filteredPlacements = filteredPlacementsList$.value;
    const inSet = [];
    const notInSet = [];
    filteredPlacements.forEach((placement) => {
      if (placementFilter$.value.has(placement.placement_id)) {
        inSet.push(placement);
      } else {
        notInSet.push(placement);
      }
    });

    inSet.sort((a, b) => a.placement.localeCompare(b.placement));
    notInSet.sort((a, b) => a.placement.localeCompare(b.placement));
    return [...inSet, ...notInSet];
  });

  return (
    <Box>
      <SearchBox>
        <Search
          onFocus={() => {}}
          ref={searchRef}
          id={searchId}
          onChange={(e) => (searchValue$.value = e.target.value)}
          value={searchValue$?.value}
          placeholder='Search Placement'
          rightIconOnClick={(event) => {
            searchValue$.value = '';
          }}
          style={{ height: '48px' }}
          Icon={getIcon}
        />
      </SearchBox>
      <Content>
        <Each
          fieldOfIndex='country_code'
          of={sortedPlacementsList$.value}
          render={({ placement, placement_id, pba_numbers }, index) => {
            return (
              <MenuItem
                style={{ width: '100%' }}
                wrapStyle={{
                  width: '100%',
                  display: 'flex',

                  alignItems: 'center',
                }}
                isSelected={false}
                height={48}
                value={placement_id}
                key={placement_id}
                onClick={handleItemClick}
              >
                <CheckboxInner
                  readOnly={true}
                  isChecked={placementFilter$.value.has(placement_id)}
                  id={placement_id}
                  name={placement}
                  onChange={() => {}}
                  style={{ marginRight: '16px' }}
                />

                <div style={{ width: '145px' }}>
                  <ParagraphWithTooltip
                    text={`${placement}`}
                    search={searchValue$.value}
                    isHighlight
                    highlightStyle={{ color: `${Palette.Primary._500}`, fontWeight: '500' }}
                  />
                </div>
                {/* <ParagraphWithTooltip
                    text={`ID:${placement_id}`}
                    search={searchValue$.value}
                    style={{
                      color: `${Palette.PrimaryGray._700}`,
                      fontWeight: '400',
                      fontSize: '12px',
                    }}
                    isHighlight
                    highlightStyle={{ color: `${Palette.Primary._500}`, fontWeight: '500' }}
                  /> */}
              </MenuItem>
            );
          }}
        />
      </Content>
      <Footer>
        <Buttons.SecondarySmall
          id={resetBtnId}
          isDisabled={!placementFilter$.value.size}
          onClick={resetClick}
        >
          Reset
        </Buttons.SecondarySmall>
        <Buttons.PrimarySmall
          id={applyBtnId}
          isDisabled={!changingFlag$.value}
          onClick={applyClick}
        >
          Apply
        </Buttons.PrimarySmall>
      </Footer>
    </Box>
  );
};

const Box = styled.div`
  width: 100%;
  height: auto;
`;

const Content = styled.ul`
  padding: 3px 3px 3px 3px;
  //overflow-x: hidden;
  display: flex;
  flex-direction: column;
  width: 226px;
  height: auto;
  max-height: 200px;
  overflow-y: auto;
  overscroll-behavior: none;
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;

const Footer = styled.div`
  display: flex;
  height: 64px;
  gap: 16px;
  justify-content: end;
  background: ${Palette.PrimaryGray._000};
  border-top: 1px solid ${Palette.PrimaryGray._200};
  border-bottom-right-radius: 4px;
  padding: 16px 24px;
`;

const SearchBox = styled.div`
  padding: 0 16px;
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
  width: 100%;
`;
